/* Clixo parts row (snippets/clixo-parts.liquid)
   - Draws the line between the numbered circles of each row (and stops at the end of a wrapped row).
   - Product pages with a parts list per variant: shows the row for the selected variant. */
(function () {
  if (window.cxPartsInit) return;
  window.cxPartsInit = true;

  function join(ul) {
    var items = [].slice.call(ul.children);
    items.forEach(function (li, i) {
      var next = items[i + 1];
      li.classList.remove('cx-join');
      if (!next || !li.offsetParent) return;
      var a = li.querySelector('.cx-parts__n').getBoundingClientRect();
      var b = next.querySelector('.cx-parts__n').getBoundingClientRect();
      if (Math.abs(a.top - b.top) > 4) return; // next piece wrapped onto a new row
      var l = li.getBoundingClientRect();
      li.style.setProperty('--join', ((b.left + b.width / 2) - (l.left + l.width / 2)) + 'px');
      li.classList.add('cx-join');
    });
  }
  function all() { document.querySelectorAll('[data-cx-parts-row]').forEach(join); }
  window.cxPartsJoin = all;

  // Variant rows: read the selected variant from the product form (or ?variant= in the URL)
  var current = null;
  function selectedVariant() {
    var input = document.querySelector('form[action*="/cart/add"] [name="id"]');
    if (input && input.value) return String(input.value);
    var m = location.search.match(/[?&]variant=(\d+)/);
    return m ? m[1] : null;
  }
  function syncVariant() {
    var rows = document.querySelectorAll('[data-cx-variant]');
    if (!rows.length) return;
    var id = selectedVariant();
    if (!id || id === current) return;
    var has = [].some.call(rows, function (r) { return r.getAttribute('data-cx-variant') === id; });
    if (!has) return;
    current = id;
    rows.forEach(function (r) { r.hidden = r.getAttribute('data-cx-variant') !== id; });
    requestAnimationFrame(all);
  }

  // Tap a piece (touch screens): it lifts and shows its name; tap it again, another piece or anywhere else to clear.
  var tapped = null, tapTimer = null;
  function clearTap() { if (tapped) tapped.classList.remove('is-tapped'); tapped = null; clearTimeout(tapTimer); }
  document.addEventListener('click', function (e) {
    var li = e.target.closest && e.target.closest('.cx-parts__item');
    if (!li) { clearTap(); return; }
    if (li === tapped) { clearTap(); return; }
    clearTap();
    tapped = li;
    li.classList.add('is-tapped');
    li._y = window.scrollY;
    tapTimer = setTimeout(clearTap, 3000);
  });
  window.addEventListener('scroll', function () { if (tapped && Math.abs(window.scrollY - (tapped._y || 0)) > 120) clearTap(); }, { passive: true });

  function start() { syncVariant(); all(); }
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', start) : start();
  window.addEventListener('load', all);
  window.addEventListener('resize', all);
  window.addEventListener('beforeprint', all);
  document.addEventListener('toggle', function () { requestAnimationFrame(all); }, true); // rows inside dropdowns measure once opened
  document.addEventListener('load', function (e) { if (e.target.classList && e.target.classList.contains('cx-parts__img')) all(); }, true);
  document.addEventListener('change', function () { setTimeout(syncVariant, 0); }, true);
  document.addEventListener('variant:change', function () { setTimeout(syncVariant, 0); });
  if (document.querySelector('[data-cx-variant]')) setInterval(syncVariant, 500);
})();
